<div
  class="pu-form-container"
  [formGroup]="form()"
>
  <div
    class="pu-form-container"
    formGroupName="delivery"
  >
    <div class="pu-form-group">
      <pu-simple-input
        formControlName="country"
        [isReadonly]="true"
        [label]="'deliveryForm.input.country*' | translate"
      />

      <pu-simple-input
        formControlName="city"
        [label]="'deliveryForm.input.city*' | translate"
      />
    </div>

    <div class="pu-form-group">
      <pu-simple-input
        formControlName="postOffice"
        [label]="'deliveryForm.input.postOffice' | translate"
      />

      <pu-simple-input
        formControlName="postTerminal"
        [label]="'deliveryForm.input.postTerminal' | translate"
      />
    </div>
  </div>
</div>
